<template>
      <el-dialog
        :visible.sync="visible"
        append-to-body
        :show-close="true"
        :center="true"
        custom-class="center-dialog"
        :before-close="handleClose"
        title="地址"
        width="500px"
        top="0vh"
      >
        <div id="container" style="width:100%;">
          <show-point :lat="lat" :lng="lng" :name="name"></show-point>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="visible = false">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import showPoint from "@/components/map/show-point.vue";

export default {
  components: {
    showPoint
  },

  data() {
    return {
      visible: false,
      lat:'',
      lng:'',
      name:''
    };
  },



    methods:{
      handleClose() {
        this.visible = false;

      },

      init(lat,lng,name) {
        this.visible = true;
        this.lat=lat;
        this.lng=lng;
        this.name=name;

      },

    }
};

</script>

<style lang="scss" scoped>
</style>
